export default __webpack_public_path__ + "media/images/dog-logo-a5b251dc5db2e15e77c2da1f57c6853b.png";